import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { PerformanceData } from 'pages/hvareporting/debtcollection/CampaignPerformanceReport';
import EvolutionSeriesChart from 'components/charts/EvolutionSeriesChart';

interface StocksSectionProps {
  data: PerformanceData[];
}

const StocksSection: React.FC<StocksSectionProps> = ({ data }) => {
  return (
    <Row className="gy-3 mb-4 justify-content-between bg-body-emphasis">
      <Col xs={12}>
        <h5>Stocks evolution</h5>
        <div className="border rounded p-3">
          <EvolutionSeriesChart data={data} />
        </div>
      </Col>
    </Row>
  );
};

export default StocksSection;
